import '.gi{margin-bottom:1.875rem;}.ssr-plugin'
import '.q{display:grid;}.ssr-plugin'
import '.m{gap:1rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { Text } from '@app/components/core/typography/Text'
import { styled } from 'inlines'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { pages } from '@app/util/links'
import useMediaQuery from '@app/util/useMediaQuery'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { ServiceProviderConceptViewModel } from 'functions/app/service-provider-concept/view'
import { labelAddressBuilder } from '@app/util/helpers'

export const Initiatives = ({
  serviceProviderConcept,
}: {
  serviceProviderConcept?: ServiceProviderConceptViewModel
}) => {
  const translations = useTranslations().app
  const isMobile = useMediaQuery()

  return (
    <Column>
      <div className="gi">
        <Title.H4 style={{ marginBottom: '0.625rem' }}>
          {translations.serviceProviderConceptPage.initiatives}
        </Title.H4>
        <Text.Medium>
          {translations.serviceProviderConceptPage.initiativesDescription}
        </Text.Medium>
      </div>
      <div className="q m"
        style={{
          gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)',}}
      >
        {serviceProviderConcept?.initiatives &&
          serviceProviderConcept.initiatives.map((initiative, index) => (
            <InitiativeCard
              key={initiative.slug}
              to={pages.initiative(initiative.slug)}
              tagText={
                initiative.searchingForMembers
                  ? translations.common.initiativeStatus.searchingForMembers
                  : translations.common.initiativeStatus.notSearchingForMembers
              }
              image={initiative.images[0]?.src ?? defaultProjectPicture}
              location={labelAddressBuilder(
                initiative.location.address,
                translations.common.notSpecified,
              )}
              phase={initiative.phase?.name}
              title={initiative.title}
              description={initiative.description}
              variant={index === 0 && !isMobile ? 'spotlight' : 'default'}
              style={
                index === 0
                  ? { gridColumn: isMobile ? 'span 1' : 'span 2' }
                  : {}
              }
            />
          ))}
      </div>
    </Column>
  )
}
